import React, { useEffect } from 'react';
import { Auth } from 'aws-amplify';
import SettingsNav from '../components/Builder/SettingsNav';
import {
  getConfigFile,
  handleUserSession,
  getTempConfigFile,
  getUsers
} from '../actions';
import { connect } from 'react-redux';
import { Loading } from 'carbon-components-react';

const SettingsContainer = state => {
  useEffect(() => {
    const loadDashboard = async () => {
      const userInfo = await Auth.currentAuthenticatedUser();
      const role = userInfo.signInUserSession.idToken.payload.role;

      if (role !== 'admin') {
        state.history.replace('/');
        return;
      }

      const token = await handleUserSession();
      token &&
        Promise.all([
          state.ConfigFile(token),
          state.TempConfigFile(token),
          state.UsersList(token)
        ]);
    };

    loadDashboard();
    // eslint-disable-next-line
  }, []);

  if (!state.configFile || !state.tempConfigFile || !state.users) {
    return <Loading />;
  }
  return <SettingsNav />;
};

const mapStateToProps = state => {
  return {
    configFile: state.configFile,
    tempConfigFile: state.tempConfigFile,
    users: state.users
  };
};

const mapDispatchToPropsActions = dispatch => ({
  ConfigFile: token => dispatch(getConfigFile(token)),
  TempConfigFile: token => dispatch(getTempConfigFile(token)),
  UsersList: token => dispatch(getUsers(token))
});

export default connect(
  mapStateToProps,
  mapDispatchToPropsActions
)(SettingsContainer);
